<template>
<div class="container-fluid">
    <div class="alert alert-info alert-dismissible">
        <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
        <h5><i class="icon fas fa-exclamation-triangle"></i> Information!</h5>
        <div><label class="text-info fly-in" style='font-weight: bold;font-family: "Times New Roman", Times, serif'><i><b>Admissions window is opened for Class ({{this.from_class}}) to ({{this.to_class}}) from Date ({{this.from_date}}) to ({{to_date}}) [Note that this excludes transfer for current students in Classes VI, VIII, and X]</b></i></label><br></div>
    </div>
    <div class="callout callout-danger" style="display:none" id="screenPermission">
        <h5 class="bg-gradient-danger">Sorry!</h5>
        <div id="validation_message"></div>
    </div>
    <div class="card card-primary card-outline"  id="main_form">
        <div class="card-body">
            <div class="form-group">
                <div class="p-2 mb-1 bg-info text-white">
                    <label > <b >Personal Details</b></label>
                </div>
                <div class="row form-group">
                    <template v-if="!is_student">
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >CID No/Reference  : </label>
                            <label class="text-primary">{{std_admission_details.CidNo}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Name of Student :</label>
                            <label class="text-primary">{{ std_admission_details.FirstName}} {{ std_admission_details.MiddleName=='null' ? '': std_admission_details.MiddleName}} {{ std_admission_details.LastName=='null' ? '': std_admission_details.LastName}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Gender :</label>
                            <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >Date of Birth :</label>
                        <label class="text-primary">{{std_admission_details.DateOfBirth}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Date of Apply :</label>
                            <label class="text-primary">{{ std_admission_details.DateOfApply}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Class :</label>
                        <label class="text-primary">{{ std_admission_details.class_id}} </label>
                        </div>
                    </template>
                    <template v-else>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >CID No/Reference  : </label>
                                <label class="text-primary">{{std_admission_details.CidNo}}</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Name of Student :</label>
                                <label class="text-primary">{{ std_admission_details.Name}} </label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Gender :</label>
                                <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                            </div>
                            <br>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Student Code :</label>
                                <label class="text-primary">{{std_admission_details.student_code}}</label>
                            </div>
                            <br>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >Date of Birth :</label>
                                <label class="text-primary">{{std_admission_details.DateOfBirth}}</label>
                            </div>
                            
                    </template>
                </div>
                <hr>
                <div class="p-2 mb-1 bg-info text-white">
                    <label > <b >Present School Details</b></label>
                </div>
                <div class="row form-group" id="present_school">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >Dzongkhag/Thromde : </label>
                        <label class="text-primary">{{this.student_form.dzongkhagName}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >School : </label>
                        <label class="text-primary">{{ this.std_present_school }} {{this.level}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label>Class : </label>
                        <label class="text-primary"><span id="present_class"></span>{{this.std_present_class}} <span v-if="this.stream">{{this.stream}}</span></label>
                    </div>
                </div>
                
                <!-- updating parents details -->
                <div class="modal fade" id="screening-modal" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ this.student_form.relation }} Details</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row form-group" >
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <label >Working Address: </label>
                                        <input type="text" class="form-control" rows="3" @change="remove_error('workingAddress')" :class="{ 'is-invalid': student_form.errors.has('workingAddress') }" id="workingAddress" v-model="student_form.workingAddress" placeholder="Working address"/>
                                        <has-error :form="student_form" field="workingAddress"></has-error>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <label >Contact Number: </label>
                                        <input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "8" minlength = "8" class="form-control" @change="remove_error('contactNumber')" :class="{ 'is-invalid': student_form.errors.has('contactNumber') }" id="contactNumber" v-model="student_form.contactNumber" placeholder="Contact No">
                                        <has-error :form="student_form" field="contactNumber"></has-error>
                                    </div>
                                </div> 
                                <div class="form_group row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <label >Residence Address: </label>
                                        <input type="text" class="form-control" rows="3" @change="remove_error('residence')" :class="{ 'is-invalid': student_form.errors.has('residence') }" id="residence" v-model="student_form.residence" placeholder="Residence Address"/>
                                        <has-error :form="student_form" field="residence"></has-error>
                                    </div>
                                </div><br>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-flat btn-sm btn-primary"  @click="UpdateParents()"> Update</button>
                                <button data-bb-handler="cancel" type="button" data-dismiss="modal" class="btn btn-flat btn-sm btn-danger">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="p-2 mb-1 bg-info text-white">
                    <label > <b >Parents/Guardian Details</b></label>
                </div>
                <div class="form-group table-responsive" >
                    <table id="list-student-left" class="table table-bordered table-striped table-head-fixed">
                        <thead>
                            <tr>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>No.</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Name</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Relation</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>CID</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Working Address</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Residence Address</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Contact Number</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, count) in parents_details" :key="count">
                                <td>{{ count + 1 }} </td>
                                <td>{{ item.Name }}</td>
                                <td>{{ item.Relationship }}</td>
                                <td>{{ item.CidNo }}</td>
                                <td>{{ item.WorkAddress }}</td>
                                <td>{{ item.ResidenceAddress }}</td>
                                <td>{{ item.ContactNo }}</td>
                                <td>
                                    <a href="#" class="btn btn-info btn-sm btn-flat text-white" @click="showedit(item)"><i class="fas fa-edit"></i > Edit</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body pb-0 mb-0">
        <div class="form-group row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="mb-0" id="err_message"></label><br>
            </div>
        </div>
    </div>
    <div class="card card-primary card-outline" id="main1">
        <div class="card-body">
            <div class="form-group">
            <label><b>Apply for Admission</b></label>
                <template v-if="!is_student">
                    <div class="row form-group" id="admissiontype">
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                            <label class="required" >Admission For:<span class="text-danger">*</span></label>
                            <input type="radio" v-model="student_form.admission_type" name="registrationType" @click="showsection('ECCD')" value="ECCD" id="new"> ECCD
                            <input type="radio" v-model="student_form.admission_type" name="registrationType" @click="showsection('PP')" value="PP" id="existing" class="ml-4"> Class PP - XII(Except Class XI Admission)
                        </div>
                    </div>
                </template>
                <div class="row form-group">
                    <small><i>(*Note: Mininum Age for PP admission should be 5 years on 5th feburary of the following year.)</i></small><br><br>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                        <label class="required">Are you a repeater?:</label>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" v-model="student_form.repeater" class="custom-control-input" id="yes" value="yes" @click="Checkrepeater('yes')">
                                <label class="custom-control-label" for="yes">Yes</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline ml-4">
                                <input type="radio" v-model="student_form.repeater" class="custom-control-input" id="no" value="no" @click="Checkrepeater('no')" :disabled="student_form.repeater === 'yes'">
                                <label class="custom-control-label" for="no">No</label>
                            </div>
                            <small><i><span style="color: orange;">(*Note: Click "Yes" only if you are a repeater; otherwise, do not switch)</span></i></small><br><br>
                        </div>
                    <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12" style="display:none" id="selectschool">
                        <div class="form-group table-responsive">
                            <table id="dynamic-table" class="table table-sm table-bordered table-striped ">
                                <thead class="p-3 mb-2 bg-info text-white border border-info">
                                    <tr >
                                        <th>No</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif' >Dzongkhag/Thromde</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>School/ECCD Centres</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Class</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Transfer Reason</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Contact Number</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:10%'>Attachment</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>School Decision</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Student Decision</th>
                                        <th class="text-start" style='font-weight: bold;font-family: "Times New Roman", Times, serif' id="actionButtonHeader">Action</th>
                                    </tr>
                                </thead>
                                <tbody class="border border-info">
                                    <tr id="record1" v-for='(item, index) in response_data' :key="index">
                                        <td>{{ index + 1 }} </td>
                                        <td>
                                            {{dzongkhagArray[item.Dzongkhagid]}}
                                        </td>
                                        <td>
                                            {{item.organization.name}}
                                        </td>
                                        <td>
                                        <span>{{item.class_id}} <span v-if="item.stream_id!='null'|| item.stream_id!='undefined'">{{item.stream_id}}</span></span> 
                                        </td>
                                        <td>
                                            <textarea class="form-control" id="exampleFormControlTextarea3" rows="4" readonly>{{item.remarks}}</textarea>
                                        </td>
                                        <td>
                                            <textarea class="form-control" id="exampleFormControlTextarea3" rows="4" readonly>{{item.contact_number}}</textarea>
                                        </td>
                                        <td v-if="item.Attachment_Path" style="width:10%">
                                            <a href="#" @click="openfile(item.Attachment_Path)" class="fa fa-download"> Download</a>
                                        </td>
                                        <td v-else>
                                            <span class="badge badge-success">Not Uploaded</span>
                                        </td>
                                        <td><span class="badge badge-success">{{item.school_decision==null ? 'Pending' : item.school_decision}} </span></td>
                                        <td><span class="badge badge-success">{{item.student_decision==null ? 'Pending' : item.student_decision}}</span> </td>
                                        <td id="actionButton">
                                            <template v-if="item.school_decision=='Accepted' && item.student_decision!='Accepted' && item.student_decision!='Rejected'">
                                                <button type="button" class="btn btn-flat btn-sm btn-primary" id="remove" @click="remove('Accepted',item.id)"><i class="fa fa-check"></i> Accept</button>
                                                <button type="button" class="btn btn-flat btn-sm bg-danger" id="remove" @click="remove('Rejected',item.id)"><i class="fa fa-times pr-2"></i> Reject</button>
                                            </template>
                                            <button  v-if="item.school_decision=='' || item.school_decision==null" type="button" class="btn btn-flat btn-sm btn-danger" id="remove" @click="remove('Remove',item.id)">Remove</button>
                                        </td>
                                    </tr>
                                    <tr id="new">
                                        <td></td>
                                        <td>
                                            <select  v-model="student_form.dzongkhag" name="dzongkhag" @change="getschoolList('dzongkhag'),removeerror('dzongkhag')"  :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('dzongkhag') }" class="form-control select2" id="dzongkhag">
                                                <option value="">Please Select</option>
                                                <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{item.name}}</option>
                                            </select>
                                            <has-error :form="student_form" field="dzongkhag"></has-error>
                                        </td>
                                        <td>
                                            <select v-model="student_form.school" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('school') }" @change="getClassList('school'),removeerror('school')" class="form-control select2" name="school" id="school">
                                                <option value=""> Please Select</option>
                                                <option v-for="(item, index) in schoolList" :key="index" v-bind:value="item.id">{{item.name}} {{item.Level}}</option>
                                            </select>
                                            <has-error :form="student_form" field="school"></has-error>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <br>
                        <div class="form-group row" id="reason">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <label class="rp-3"><u>Brief description for seeking transfer:<span class="text-danger">*</span></u></label><br>
                                <textarea class="form-control" v-model="student_form.remarks" :class="{ 'is-invalid': student_form.errors.has('remarks')}" id="remarks"  @change="remove_error('remarks')"></textarea>
                                <has-error :form="student_form" field="remarks"></has-error>
                            </div>
                        </div>
                        <div class="form-group row" id="attach">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <small><i>(*Note: Note: All the related documents need to be compiled into one document and upload)</i></small>
                                <label>Supporting Document:<span class="text-danger">*</span>(Max File Size 1.5 MB)</label><br>
                                
                                <small><i>(Any document that will strengthen your application to the new school e.g concern letter)</i></small>
                                <!-- <small><i>Documents required (CID copy of the Parent's and Parent's concern letter)</i></small> -->
                                <input type="file" name="attachments" class="form-control" v-on:change="onChangeFileUpload" id="attachment">
                                <has-error :form="student_form" field="attachments"></has-error>
                            </div>
                        </div>
                        <div class="card card-primary" id="result">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <label>Result:</label>
                                <label class="text-success center" v-if="this.promoted =='1'">PASS</label><br>
                                <label class="text-danger center" v-if="this.promoted =='0'">FAIL</label><br>
                            </div>
                        </div>
                        <div class="form-group row"  id="optClass">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <label>Select class:<span class="text-danger">*</span></label>
                                <select v-model="student_form.class" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('std_class') }" class="form-control select2" name="std_class" id="std_class">
                                    <option v-for="(item, index) in classListByOrgId" :key="index" v-bind:value="item.id">{{ item.class }}</option>
                                </select>
                                <has-error :form="student_form" field="std_class"></has-error>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" id="contact_number">
                                <label >Contact Number:<span class="text-danger">*</span> </label>
                                <input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "8" minlength = "8" class="form-control" @change="remove_error('ImmediateConatct')" :class="{ 'is-invalid': student_form.errors.has('ImmediateConatct') }" id="ImmediateConatct" v-model="student_form.ImmediateConatct" placeholder="Contact No">
                                <has-error :form="student_form" field="ImmediateConatct"></has-error>
                            </div>
                        </div>
                        <br>
                        <div class="card-footer text-right">
                            <button type="button" class="btn btn-flat btn-sm btn-primary" id="addMore" @click="addMore()">Submit</button>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
            class_array:['AGE 2','AGE 3','AGE 4','AGE 5','PP', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII','XII'],
            is_student:false,
            std_id:'',
            std_class:'',
            classDecreased: false,
            localClass: null,
            std_present_class:'',
            std_present_school:'',
            level:'',
            org_id:'',
            from_class:'',
            stream:'',
            to_class:'',
            from_date:'',
            to_date:'',
            checkPassFail:'',
            Attachment_Path:[],
            adm_start_date:'',
            adm_end_date:'',
            parent_school_dzongkhag:'',
            genderArray:{},
            dzongkhagArray:{},
            gewogArray:{},
            villageArray:{},
            OrgDetails:'',
            dzongkhagList:[],
            schoolList:[],
            classList:[],
            promoted:'',
            classListByOrgId:[],
            streamList:[],
            stdList:[],
            s_classList:[],
            parents_details:[],
            std_admission_details:'',
            ppdob:'',
            eccddob:'',
            ppmonth:'',
            eccdmonth:'',
            response_data:[],
            Repeater:'',
            draft_attachments:[],
            //prefedined an array of the classes
            student_form: new form({
                id:'',
                student:'',
                admission_type:'',
                student_id:'',
                residence:'',
                dzongkhag:'',
                school:'',
                class:'',
                dateOfapply:'',
                attachments:'',
                remarks:'',
                std_decission:'',
                relation:'',
                workingAddress:'',
                contactNumber:'',
                ImmediateConatct:'',
                admission_from:'portal',
                submitter:'student',
                repeater:'no',
            })
        }
    },
    methods:{
        openfile(file){
            let file_path=file.replaceAll('/', 'SSS');
            let uri = 'admissions/viewFiles/'+file_path;
            window.open(uri,"_black");
        },
        
        showedit(item){
            if(item!="" || item!=[] || item!=null){
                // Show the modal
                $('#screening-modal').modal('show');
                this.clearFormValues();
            // Set form properties
                this.student_form.relation = item.Relationship;
                this.student_form.workingAddress = item.WorkAddress;
                this.student_form.contactNumber = item.ContactNo;
                this.student_form.residence = item.ResidenceAddress;
            }
        },
        clearFormValues() {
                // Clear form values
                this.student_form.relation = '';
                this.student_form.workingAddress = '';
                this.student_form.contactNumber = '';
                this.student_form.residence = '';
        },

        UpdateParents(){
                Swal.fire({
                    text: "Are you sure you want update this details ?",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!',
                    }).then((result) => {
                    if(result.isConfirmed){
                        let formData = new FormData();
                        formData.append('student', this.student_form.student);
                        formData.append('student_id', this.student_form.student_id);
                        formData.append('workingAddress', this.student_form.workingAddress);
                        formData.append('contactNumber', this.student_form.contactNumber);
                        formData.append('residence', this.student_form.residence);
                        formData.append('relation', this.student_form.relation);
                        axios.post('/admissions/UpdateParents',formData)
                        .then((response) => {
                            let data = response.data;
                            if(data!=null){
                                Swal.fire({
                                text: "You have update details successfully",
                                icon: 'info',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Okay!',
                                });
                            }
                            else{
                                Swal.fire({
                                text: "Unexpected Error. Please try it again",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Okay!',
                                });
                            }  
                            this.$router.push('/apply_for_school');
                            $('#screening-modal').modal('hide');
                            window.location.reload();     

                        })
                        .catch((error) => {
                            console.log("Error addMore:"+error);
                        })
                    }
                }); 
        },
        getclassList(id){
            this.classList = [];
            axios.get('/masters/loadClassAge')
            .then(Response =>{
                let data = Response.data.data;
                this.s_classList = data;
            })
        },
        onChangeFileUpload(e){
            this.fileSize = 0;
            this.fileSize = e.target.files[0].size;
            this.maxSize = '1572864';
            if(this.fileSize >=this.maxSize){
                Swal.fire({
                    text: "Please check your uploaded file size",
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Okay!',
                });
                $('#addMore').hide();
                event.target.value = ''; // Clear the input value
            }
            else{
                $('#addMore').show();
            }

            this.student_form.attachments = e.target.files[0];
        },
    async getStuentparentDetails(id){
        await axios.get('admissions/getStuentparentDetails/'+id+'__PARENTS')
            .then(response => {
                let data = response.data;
                if(data!="" || data!=null || data!=undefined){
                    this.parents_details=data;
                }
                else{
                    this.parents_details = [];
                }
            })
            .catch(function (error) {
                console.log("Error......"+error)
            });
        },
        async addMore(){
            let is_valid_age =true;
            let orgId=this.student_form.school;
            await axios.get('/admissions/checkSchoolLevelByOrgId/'+orgId)
            .then(Response =>{
                if(Response!=null && Response!=""){
                    let level = JSON.stringify(Response.data[0].name);
                    let dob = this.std_admission_details.DateOfBirth;
                    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                    let date1 = new Date(dob);
                    let date2 = '';
                    if(level.includes('Early Child Care')){
                        date2 = new Date(this.eccdAdmissionDateValidation);
                    } else {
                        date2 = new Date(this.schoolAdmissionDateValidation);
                    }
                    const dob_date = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                    const admission_date = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

                    let age = Math.floor((admission_date-dob_date) / _MS_PER_DAY);
                    if(level.includes('Early Child Care')){
                        if(age <=1096){
                            is_valid_age = false;
                        }
                    } else {
                        if(age <=1825){
                            is_valid_age = false;
                        }
                    }
                    if(!is_valid_age){
                        $('#addMore').hide();
                        let text = 'Child does not meet the Minimum age requirement for Admission';
                        this.showErrorMsg(text);
                    }
                    if(is_valid_age){
                        const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }    
                Swal.fire({
                    text: "Are you sure you wish to save this details ?",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!',
                    }).then((result) => {
                    if(result.isConfirmed){
                        const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                    }
                        let formData = new FormData();
                        formData.append('student', this.student_form.student);
                        formData.append('admission_type', this.student_form.admission_type);
                        formData.append('student_id', this.student_form.student_id);
                        formData.append('dzongkhag', this.student_form.dzongkhag);
                        formData.append('school', this.student_form.school);
                        formData.append('class', this.student_form.class);
                        formData.append('stream', this.stream);
                        formData.append('std_class', this.std_class);
                        formData.append('dateOfapply', this.student_form.dateOfapply);
                        formData.append('remarks', this.student_form.remarks);
                        formData.append('std_decission', this.student_form.std_decission);
                        formData.append('workingAddress', this.student_form.workingAddress);
                        formData.append('contactNumber', this.student_form.contactNumber);
                        formData.append('ImmediateConatct', this.student_form.ImmediateConatct);
                        formData.append('residence', this.student_form.residence);
                        formData.append('relation', this.student_form.relation);
                        formData.append('actiontype', 'portal');
                        formData.append('submitter', 'student');
                        formData.append('AdmissionType', 'Transfer');
                        formData.append('admission_from', 'Online');
                        formData.append('attachments', this.student_form.attachments);
                        axios.post('/admissions/saveorgclassDetails',formData, config)
                        .then((response) => {
                            let data = response.data;
                            if(data.match("applied")){
                                Swal.fire({
                                text: "You have already applied to the selected school, Please check on the applied school lists above",
                                icon: 'warning',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Okay!',
                                });
                            }
                            else if(data.match('created')){
                                this.loadadmissions(data.StdAdmissionsId);
                                let message="You have applied to school successfully";
                                this.$router.push({name:'apply_for_school_ackowlegement',params: {data:message}});
                            }
                            else{
                                Swal.fire({
                                text: "Unexpected Error. Please try it again",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Okay!',
                                });
                            }          
                            // this.student_form.school='';
                            // this.student_form.class='';
                            // this.getParentSchoolDzo();
                        })
                        .catch((error) => {
                            Toast.fire({
                                icon: 'warning',
                                title: 'Please fill up all required information before submitting your application'
                            });
                            console.log("Error:"+error);
                        })
                        // window.location.reload();
                    }
                });
                        $('#addMore').show();
                    }
                }
            }).catch(error => console.log(error));
        },
        loadadmissions(id){
            this.student_form.student_seats=[];
            axios.get('/admissions/getorgclassDetails/'+id)
            .then(Response =>{
                let data = Response.data;
                if(data!='null' || data!=""){
                    this.response_data=data;
                }
                this.filepth= data.Attachment_Path;
                for(let i=0;i<=data.length;i++){
                    if(data[i].school_decision=='Accepted' && data[i].student_decision=='Accepted' ){
                        $('#addMore').hide();
                    }
                }
            }).catch(error => console.log(error));
        },
        /**
         * method to remove fields
         */
        remove(type,id){
            Swal.fire({
                text: "If you take this action you cannot undo back again",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    axios.get('/admissions/deleteclassDetails/'+id+'__'+type)
                    .then((response) => {
                        let data=response.data;
                        if(data.match('Accepted')){
                            // this.$router.push({name:'acknowledgement'});
                            let message="Your decision of accepting for selected school has been updated successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                        }
                        else if(data.match('Rejected')){
                            let message="Your decision of rejecting for selected school has been updated successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                            
                        }
                        else if(data.match('Deleted')){
                            let message="Your have removed school successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                            
                        }
                    })
                    .catch((error) => {
                        console.log("Error remove:"+error);
                    })
                }
            });
        },
        getdzongkhagList(type){
            let uri ='masters/loadGlobalMasters/all_active_dzongkhag';
            axios.get(uri)
            .then(Response =>{
                let data = Response.data.data;
                this.dzongkhagList = data;
                for(let i=0;i<data.length;i++){
                    this.dzongkhagArray[data[i].id] = data[i].name;
                }
                $('#dzongkhag').prop('disabled',false);
            }).catch(error => console.log(error));
        },
        async getstudentPersonalDetails(type){
            await axios.get('/admissions/getStudentDetailsFromPortal/'+type)
                .then(response => {
                let data = response.data;
                if(data != "" || $data!=""){
                    this.getStuentparentDetails(data.id);
                    this.DateOfBirth = data.DateOfBirth;
                    this.student_form.DateOfBirth = data.DateOfBirth
                    this.validateAge(this.DateOfBirth);
                    this.std_admission_details=data;
                    if(data.id!=null && data.id!=""){
                        this.getStudentClass(data.id);
                    }
                else{
                        this.getStudentClass(data.StdAdmissionsId);
                }
                    this.org_id = this.std_admission_details.OrgOrganizationId;
                    this.getOrgDetails(data.OrgOrganizationId)

                    //Function to load the school list as per feeders
                    if(type == 'Student'){
                        let uri2 ='organizations/loadOrganizationDetailsbyOrgId/'+this.org_id;
                        axios.get(uri2)
                        .then(Response =>{
                            if(Response!="" || Response!=null){
                                let dzongkhag_data = Response.data.data;
                                this.parent_school_dzongkhag = dzongkhag_data.dzongkhagId;
                                this.std_present_school = dzongkhag_data.name;
                                this.level=dzongkhag_data.level_name;
                                // this.student_form.dzongkhag = this.parent_school_dzongkhag;
                                // $('#dzongkhag').prop('disabled',true);
                                // this.getParentSchoolList(dzongkhag_data.id);
                            }
                        }).catch(error => console.log(error));

                        // this.student_form.student_id=data.id;
                        let AdmissionType='ParentSchool';
                        this.student_form.admission_type=AdmissionType;
                        $("input[name=registrationType][value=" + AdmissionType + "]").prop('checked', true);
                    } else {
                        // this.student_form.student_id=data.id;
                        // this.std_class=data.class_id;
                        this.student_form.admission_type=data.AdmissionType;
                        $("input[name=registrationType][value=" + data.AdmissionType + "]").prop('checked', true);
                    }
                    this.showsection(data.AdmissionType)
                    this.getGewogList(data.CmnDzoId,data.CmnGewogId);
                    this.getvillagelist(data.CmnGewogId,data.CmnChiwogId);
                }
                else{
                    $('#main_form').hide();
                    $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                    $('#screenPermission').show();
                }
            });
        },
        LoadFinalResultByStudentId(year){
            // this.term_year = this.academic_year+'__'+term+'__'+this.classId+'__'+this.selectclass;
            // axios.get('results/LoadFinalResultByStudentId/' +this.student_code+ '/' + this.term_year)
            axios.get('results/LoadFinalResultByStudentId/' +this.student_code+ '/' +year)
                .then(response => {
                    if(response.data.data!="" && response.data.data!=null){
                        let data = response.data.data;
                        this.promoted = data[0].t_promoted;
                        $('#result').show();
                    }
                    else{
                        this.promoted = '0';
                    }
                });
        },
        async getStudentClass(std_id){
            let uri = '/students/getStudentClassId/'+ std_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data;
                    if(data!="" && data!=null){
                     //have to check whether the student passed or failed
                        this.std_present_class = data.student_data[0].class;
                        if(this.std_present_class=='X' || this.std_present_class=='10'){
                            $('#main_form').hide();
                            $('#main1').hide();
                            $('#validation_message').html('This Interface is restricted for Class XI admission, Please proceed  either from (Class XI to Private School) or (Class XI within Cluster) interface. <br> Thank you!');
                            $('#screenPermission').show();
                        }
                        // else if(this.std_present_class!='VIII' || this.std_present_class=='8'){
                        //     $('#addMore').hide();
                        //     $('#new').hide();
                        //     $('#selectschool').hide();
                        //     $('#validation_message').html('Admission is only open for current class VIII students. <br> Thank you!');
                        //     $('#screenPermission').show();
                        // }
                        this.stream = data.stream;
                        let is_valid_age=this.validateAge();
                        //checking Age for class selection
                        if(is_valid_age > 5){
                            $('#age').show();
                            $('#class').hide();
                            $('#allClass').hide();
                        }
                        //checking for result for class VIII
                        // else if(this.promoted == '0'){
                        //     this.std_class =  this.std_present_class;
                        // }
                        else{
                            const currentIndex = this.class_array.indexOf(this.std_present_class);
                            if (currentIndex !== -1 && currentIndex < this.class_array.length - 1) {
                                this.std_class = this.class_array[currentIndex + 1];
                                this.classList.push(this.std_class);
                                this.student_form.class = this.std_class;
                            } else {
                                // Handle the case when this.std_present_class is not found or is the last element
                                // Add appropriate logic here based on your requirements
                            }

                        }
                    }
                    else{
                        $('#age').hide();
                        $('#class').hide()
                        $('#allClass').show();
                        // $('#optClass').hide();
                        // $('#result').hide();
                    }
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },
        checkForPreviousYearStudent(student_code){
            let uri = '/students/checkForPreviousYearStudent/'+ student_code;
                axios.get(uri).then(response => {
                    if(response.data!=null && response.data!=""){
                        $('#age').hide();
                        $('#class').show();
                        $('#allClass').hide();
                    }
                    else{
                        $('#age').hide();
                        $('#class').hide();
                        $('#allClass').show();
                    }
                });
        },
        validateAge(dob){
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            let date1 = new Date(dob);
            let date2 = '';
            if(this.org_type == 'ECCD'){
                date2 = new Date(this.eccdAdmissionDateValidation);
            } else {
                date2 = new Date(this.schoolAdmissionDateValidation);
            }

            const dob_date = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
            const admission_date = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

            let age = Math.floor((admission_date-dob_date) / _MS_PER_DAY);
            let is_valid_age=0;
                if(age <=1096){ //age 3
                    is_valid_age = 3;
                }
                else{ //age 4
                    is_valid_age = 5; 
                }
            return is_valid_age;

        },

        checkSchoolList(orgId){
            for(let i=0;i<this.response_data.length;i++){
                if(this.response_data[i].organization.id == orgId){
                    return false;
                }
            }
            return true;
        },

        getstreamListByid(id){
            let classId=$('#class').val();
            if(id!=""){
                classId=id;
            }
            axios.get('/masters/getStreamByclassId/' +classId)
            .then(Response =>{
                let data = Response.data;
                this.classList = data;
            })
        },

        getOrgDetails(id){
            axios.get('/organizations/loadOrganizationDetailsbyOrgId/' +id)
            .then(response =>{
                let data = response.data.data;
                if(data!="" ||data!=null){
					this.student_form.dzongkhagName=data.dzongkhag;
					this.student_form.gewog=data.gewog;
					this.student_form.chewog=data.chewog;
				}	
            })
        },
        getGewogList(dzongkhag,gewog_id){
            let uri = 'masters/all_active_dropdowns/dzongkhag/'+dzongkhag;
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                for(let i=0;i<data.length;i++){
                    this.gewogArray[data[i].id] = data[i].name;
                }
                $('#gewogid').html(this.gewogArray[gewog_id]);
            });
        },

        getvillagelist(gewogId,vilId){
            let uri = 'masters/all_active_dropdowns/gewog/'+gewogId;
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                for(let i=0;i<data.length;i++){
                    this.villageArray[data[i].id] = data[i].name;
                }
                $('#vilageId').html(this.villageArray[vilId]);
            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },
        applyselect(){
            if(!$('#dzongkhag').attr('class').includes('select2')){
            $('#dzongkhag').addClass('select2');
            }
            if(!$('#school').attr('class').includes('select2')){
            $('#school').addClass('select2');
            }
            if(!$('#class').attr('class').includes('select2')){
            $('#class').addClass('select2');
            }
            if(!$('#stream').attr('class').includes('select2')){
            $('#stream').addClass('select2');
            }
        },
        loadGenderList(uri="masters/loadGlobalMasters/all_active_gender"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.sex_idList =  data.data.data;
                for(let i=0;i<data.data.data.length;i++){
                    this.genderArray[data.data.data[i].id] = data.data.data[i].name;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        removeerror(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
            }
        },

        async changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
            if(id=="std_class"){
                this.student_form.class=$("#std_class option:selected" ).text();

            }
            if(id=="dzongkhag"){
                this.student_form.dzongkhag=$('#dzongkhag').val();
                this.getschoolList(this.student_form.dzongkhag);
            }
            if(id=="school"){
                this.student_form.school=$('#school').val();
                this.getClassList(this.student_form.school);
            }
        },
        getstudentBasicDetailsForPortal(id){
            axios.get('/admissions/getstudentBasicDetailsForPortal/'+id)
                .then(response => {
                let data = response.data;
                if(data != "" || data!=null){
                    $('#student_id').prop('disabled',true);
                    this.std_admission_details=data;
                    this.std_class=data.class_id;
                    this.org_id = this.std_admission_details.OrgOrganizationId;
                    this.showsection(data.AdmissionType)

                    if(this.std_class.match("AGE")){
                        this.student_form.admission_type='ECCD';
                        $('#new').prop('disabled',true);
                        $('#existing').prop('disabled',true);
                    }
                    else{
                        this.student_form.admission_type='PP';
                        $('#new').prop('disabled',true);
                        $('#existing').prop('disabled',true);
                    }
                    
                }
                else{
                    $('#main_form').hide();
                    $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                    $('#screenPermission').show();
                }
            });

        },
        getClassList(school){
        // //Added temppary solution for class V repeater
        //     if(this.std_present_class=='V' && student_form.repeater== true){
        //         this.std_class = this.std_present_class;
        //     }
            let uri = '/organizations/loadClassListForAdmissionWindow/'+ school+'/'+this.from_class+'/'+this.to_class+'/'+this.std_class;
            try{
                this.classListByOrgId =[];
                axios.get(uri).then(response => {
                    let data= response.data;
                    if(data!=null && data!=''){
                        this.classListByOrgId=data;
                        $('#attach').show();
                        $('#reason').show();
                        $('#optClass').show();
                        $('#contact_number').show();
                        $('#addMore').show();
                    }
                });
            }catch(e){
                console.log('error '+e);
            }
        },
          //added new function for checked repeater or not
        Checkrepeater(value) {
            this.repeater = value;
            this.schoolList = [];  // Use '=' for assignment
            this.dzongkhagList = [];
            this.getdzongkhagList();
            // if(value=='no'){
                // Add logic to refresh the page
                // window.location.reload();

            // }
        },

        async getschoolList(dzo_id){
            this.schoolList ==[];
            this.student_form.dzongkhag=dzo_id;
            var type;
            if(this.is_student){
                type = this.std_class;
                if(this.std_class.match('AGE')){
                    type="ECCD";
                }else{
                    type="School";
                }
                if(this.std_class == ''){
                    // this.std_class=this.student_form.class;
                    type = 'General';
                    this.std_class = 'General';
                }
            } else{
                type=$('input[name="registrationType"]:checked').val();
            }
            
            //CHECKING WHEATHER IS REPEATER OR NOT
            if(this.repeater=='yes' && this.std_class!='XII'){
                if (!this.classDecreased) {
                    const currentIndex = this.class_array.indexOf(this.std_class);
                    if (currentIndex !== -1 && currentIndex > 0) {
                        this.std_class = this.class_array[currentIndex - 1];
                        this.classDecreased = true;
                    }
                }
            }
            //added if condition by tshewang to get school list, once student type is chaged to student. school list is not appearing as type is empty
            
            // let uri = '/organizations/loadSchoolList/'+ $('#'+dzo_id).val()+'/'+type;
            let uri = '/organizations/loadSchoolListForPortal/'+ dzo_id +'/'+type +'/'+ this.std_class;
            try{
                this.schoolList = [];
                axios.get(uri).then(response => {
                    let data= response.data;
                    this.schoolList=data;
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }

        },
        //admission validation
        loadAdmissionDateValidation(){
            let uri='masters/loadValidationcondition';
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                this.schoolAdmissionDateValidation  = data.date1;
                this.eccdAdmissionDateValidation  = data.date;
                this.eccdValidationDuration  = data.no_months;
                this.schoolValidationDuration  = data.no_months1;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });

        },

        showErrorMsg(text){
            Swal.fire({
                html: text,
                icon: 'error'
            });
        },
        showsection(type){
            let dob=new Date(this.std_admission_details.DateOfBirth);
            let isvalid=true;
            let messages="";
            if(this.is_student){
                $('#selectschool').show();
                $('#validationmessages').hide();
            } else {
                if(type=="ECCD"){
                    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                    let dob=this.std_admission_details.DateOfBirth;
                    let date1 = new Date(dob);
                    let date2 = new Date(this.eccddob);

                    // Discard the time and time-zone information.
                    const dob_date = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                    const admission_date = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

                    let eecdage = Math.floor((admission_date-dob_date) / _MS_PER_DAY);
                    if(eecdage <=1096){
                        messages="You need to attained the minimum required age";
                        $('#dzo_Section').hide();
                        $('#seatAvailable').hide();
                        $('#selectschool').hide();
                        $('#validation_message').html(messages);
                        $('#validationmessages').show();
                    } else {
                        $('#selectschool').show();
                        $('#finalbtn').show();
                        $('#validationmessages').hide();
                    }
                }
            }
        },
        checkForAdmissionWindow() {
            axios.get('masters/loadGlobalMasters/apply')
                .then(response => {
                    let data = response.data.data;

                    if (data != null) {
                        let from_date = data.from_date;
                        let to_date = data.to_date;
                        this.from_class = data.from_class;
                        this.to_class = data.to_class;
                        this.from_date = data.from_date;
                        this.to_date = data.to_date;

                        var today = new Date();
                        let month = today.getMonth() + 1;
                        let date = today.getDate();

                        // Add leading zeros to month and date if needed
                        month = month.toString().length === 1 ? '0' + month : month;
                        date = date.toString().length === 1 ? '0' + date : date;

                        var present_date = today.getFullYear() + '-' + month + '-' + date;

                        if (to_date >= present_date && from_date <= present_date) {
                            $('#selectschool').show();
                            $('#finalbtn').show();
                            $('#validationmessages').hide();
                        } else {
                            $('#addMore').hide();
                            // $('#optClass').hide();
                            $('#new').hide();
                            $('#validation_message').html('The Admission Dates are closed. <br> Thank you!');
                            $('#screenPermission').show();
                        }
                    }
                })
                .catch(errors => {
                    console.log(errors);
                });
        },

    },
    async mounted() {
        $('.select2').select2();
        $('.select2').select2({
            theme: 'bootstrap4'
        });
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });

        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
        // $('#pass').hide();
        // $('#fail').hide();
        // $('#NotPublished').hide();
        $('#result').hide();
        $('#attach').hide();
        $('#reason').hide();
        $('#optClass').hide();
        $('#contact_number').hide();
        $('#addMore').hide();
        this.getclassList();
        this.Checkrepeater();
        this.loadAdmissionDateValidation();
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.userId=data.id;;
            // this.loadStudentList(this.userId)
            this.std_id=data['std_id'];
            this.student_code = data['student_code'];
            this.dob = data['dob'];
            this.checkForPreviousYearStudent(this.student_code);
            this.getStuentparentDetails(this.std_id);
            this.id = data['id'];
            this.loadadmissions(this.std_id);

            let user_type=data['user_type'];
            if(data['user_type']=="Student"){
                this.student_form.student_id=data.std_id;
                this.is_student=true;
                this.getOrgDetails(data.organization_id);
                $('#selectStudent').hide();
                this.getstudentPersonalDetails(user_type);
            }
            else{
                $('#present_school').hide();
                $('#pheader').hide();
                
            }
            this.getdzongkhagList(user_type);
            this.checkForAdmissionWindow();
            this.LoadFinalResultByStudentId(2022);

        })
        .catch(errors => {
            console.log(errors)
        });

        // this.loadVlidation();
        this.loadGenderList();
        
        
    },
}
</script>
